import React, { ReactNode, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import SwiperCore, {
    SwiperOptions,
    Navigation,
    Thumbs,
    Controller,
    Autoplay,
    Pagination,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import stylesPc from "./ThumbsGallery.module.css";
import stylesSp from "./ThumbsGallery_SP.module.css";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
import "./SwiperPagination.css";
import { RecommendVideo } from "../../../../common/homePage/model/HomePage";
import PuiTypography from "../../../../components/elements/PuiTypography";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import WhitePlayIcon from "../../../../common/components/images/WhitePlayIcon";
import { Button } from "@material-ui/core";
import { t } from "i18next";

SwiperCore.use([Pagination, Navigation, Thumbs, Controller, Autoplay]);
interface GalleryProps {
    videoList: RecommendVideo[];
}
export default function ThumbsGallery({ videoList }: GalleryProps) {
    const history = useHistory();
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;
    const [swiperSlides, setSwiperSlides] = useState<ReactNode[]>([]);

    const params: SwiperOptions = {
        pagination: {
            clickable: true,
        },
        loop: true,
        autoplay: {
            delay: 5000,
        },
        centeredSlides: true,
    };

    const HoverSlide = () => {
        const header = document.getElementById("header");
        if (header) {
            header.style.backgroundColor = "#07080A";
        }
    };

    const LeaveSlide = () => {
        const header = document.getElementById("header");
        if (header) {
            header.style.backgroundColor = "";
        }
    };

    // サムネイルコンテンツの生成
    useEffect(() => {
        if (videoList.length > 0) {
            const slideList: ReactNode[] = [];
            videoList?.forEach((video) => {
                slideList.push(
                    <SwiperSlide key={video.id} className={styles.slide}>
                        <div className={styles.slideImg}>
                            <div
                                className={styles.icon}
                                style={{
                                    width: IsDevice("desktop") ? "60px" : "45px",
                                    top: IsDevice("iphone") ? "28%" : "40%",
                                    left: IsDevice("iphone") ? "44%" : "48%",
                                }}
                                onClick={() => history.push(`/video/${video.id}`)}
                            >
                                <WhitePlayIcon />
                            </div>
                            <img id={"currentThumb"} src={video.imageUrl} alt={video.id} />
                            {IsDevice("desktop") && (
                                <div className={styles.hoverDiscription}>
                                    <div className={styles.background} />
                                    <div
                                        className={styles.title}
                                        style={{
                                            bottom: IsDevice("desktop")
                                                ? "100px"
                                                : IsDevice("ipad")
                                                ? "80px"
                                                : "30px",
                                            left: IsDevice("desktop")
                                                ? "90px"
                                                : IsDevice("ipad")
                                                ? "50px"
                                                : "40px",
                                        }}
                                    >
                                        <PuiTypography
                                            bold={true}
                                            size={IsDevice("desktop") ? 30 : 16}
                                        >
                                            {video.title}
                                        </PuiTypography>
                                        <div className={styles.discription}>
                                            <PuiTypography size={IsDevice("desktop") ? 17 : 10}>
                                                {video.description}
                                            </PuiTypography>
                                        </div>
                                        <Button
                                            className={styles.playBtn}
                                            style={{
                                                fontSize: IsDevice("desktop") ? "18px" : "14px",
                                            }}
                                            onClick={() => history.push(`/video/${video.id}`)}
                                        >
                                            {t("動画を再生する")}
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </SwiperSlide>
                );
            });
            setSwiperSlides(slideList);
        }
        // eslint-disable-next-line
    }, [videoList, history]);

    return (
        <>
            {videoList.length > 0 && (
                <div
                    className={styles.container}
                    onMouseEnter={HoverSlide}
                    onMouseLeave={LeaveSlide}
                >
                    <Swiper {...params}>{swiperSlides}</Swiper>
                    {/* <div className={styles.playIcon} onClick={() => handleClick()}>
                        {focusThumb && <PlayIcon />}
                    </div> */}
                </div>
            )}
        </>
    );
}
